import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, message, Modal, Row } from 'antd'
import { useLocation, Redirect, useHistory } from 'react-router'
import {
  addCustomPatient,
  setNewPatient,
} from '../../store/action/patient.action'
import { assignDevices, assignPlan } from '../../store/action/device.action'
import { assignRegimens } from '../../store/action/regimen.action'
import { setExercises } from '../../store/action/schedule.action'
import List from './schedule.list'
import '../../css/schedule.scss'
import serviceInterface from '../../services/service.interface'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { constants } from '../../constants'
import _ from 'lodash'

const Form = (props) => {
  console.log('props schedule form--->', props)
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    console.log('----------EXERCISES-----------', props)
    location.state?.assignedDevices &&
      props.assignDevices(location.state?.assignedDevices)
    location.state?.assignedPlan &&
      props.assignPlan(location.state?.assignedPlan)
    !props.newPatient?.age && props.setNewPatient(location.state.patient)
    props.assignRegimens(location.state.regimens)
  }, [])

  useEffect(() => {
    var exercises = serviceInterface
      .ScheduleService()
      .getExerciseArray(props.assignedRegs)

    props.setExercises(exercises)
  }, [props.assignedRegs])

  const PatientCreatedBox = (devlen) => {
    Modal.confirm({
      title:
        devlen > 0 ? (
          <div>
            <b>{`${devlen} devices ordered for the new patient ${_.upperFirst(props.newPatient?.firstname)} ${_.upperFirst(props.newPatient?.lastname)}. `}</b>
          </div>
        ) : (
          'Patient created Successfully'
        ),
      icon: <ExclamationCircleOutlined />,
      content: devlen > 0 ? constants.MESSAGE.ORDER_PLACED : '',
      okText: 'Ok',
      cancelButtonProps: { hidden: 'true' },
    })
  }

  var handleNext = async (e) => {
    if (!Array.isArray(props.exercises) || props.exercises.length <= 0) {
      //message.error('Add atleast one exercise1')
      //return;
    }
    history.push({
      pathname: '/patient/add/questionnaire',
      state: {
        patient: props.newPatient,
        devices: props.devices,
        assignedPlan: props.plan,
        assignedDevices: props.assignedDevices,
      },
    })
    // var response = await props.addPatient({...props.newPatient, careplan:props.assignedPlan._id, include_regimens:props.assignedPlan.include_regimens},props.assignedDevices, props.exercises);
    // if (response)
    // {
    //     PatientCreatedBox(props.assignedDevices?.length);
    //     history.push('/patient');
    // }
  }

  var handleBackClick = () => {
    Modal.confirm({
      title: 'Are you sure you want to leave this page?',
      icon: <ExclamationCircleOutlined />,
      content: 'Your changes will be lost if you go back.',
      okText: 'Yes',
      cancelText: 'No',
      onOk: handleBack,
    })
  }

  var handleBack = () => {
    history.push({
      pathname: '/patient/add/regimens',
      state: {
        patient: props.newPatient,
        regimens: props.assignedRegs,
        assignedPlan: props.assignedPlan,
      },
    })
    return Promise.resolve()
  }

  return (
    <>
      {/* {!location.state?.patient && <Redirect to="/patient/add/info" />} */}
      <Row className='scheduleContainer'>
        <Col flex={'auto'}>
          <List handleNext={handleNext} handleBack={handleBackClick} />
        </Col>
      </Row>
    </>
  )
}

Form.propTypes = {
  customer: PropTypes.object,
  assignedRegs: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    newPatient: state.patient.newpatient,
    assignedRegs: state.regimen.assignedRegs,
    exercises: state.schedule.exercises,
    assignedDevices: state.device.assignedDevices,
    assignedPlan: state.device.assignedPlan,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setNewPatient: (patient) => dispatch(setNewPatient(patient)),
    assignRegimens: (regimens) => dispatch(assignRegimens({ regimens })),
    setExercises: (exercises) => dispatch(setExercises(exercises)),
    addPatient: (patient, devices, exercises) =>
      dispatch(addCustomPatient({ patient, devices, exercises })),
    assignPlan: (plan) => dispatch(assignPlan(plan)),
    assignDevices: (devices) => dispatch(assignDevices(devices)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form)
